module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": _vm.rows,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78e97ca7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/regularTextarea.vue
// module id = 841
// module chunks = 1